/**
 * @desc 收款码支付结果页面校验接口，用于微信支付结果页点金计划的参数校验，以及获取交易信息
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** url */
  url: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/goldPlanPaymentResult',
    params,
    method: 'get',
  })
}
